<template>

  <MediaLibraryModal
      :showModal="showModal"
      :changeUploadBoxState="changeUploadBoxState"
      :fileType="fileType"
      :select="select"
      :uploadBoxState="uploadBoxState"
      :provider_id="provider_id"
  />

</template>

<script>
import MediaLibraryModal from '@/Pages/Media/MediaLibraryModal.vue'

export default {
	name: 'MediaLibrary',
  components: {
      MediaLibraryModal,
  },
  props: ['uploadBoxState', 'changeUploadBoxState', 'select', 'provider_id'],
  data(){
    return{
      showModal: false,
      fileType: null,
    }
  },
  watch:{
      uploadBoxState: function (newState, oldState){
        // @TODO: kann mit in die assoc liste
          if(newState == 'preview_file'){
            this.showModal = true;
            this.fileType = 'image';
          }
          if(newState == 'logo_file'){
            this.showModal = true;
            this.fileType = 'image';
          }
          if(newState == 'gallery_image'){
            this.showModal = true;
            this.fileType = 'image';
          }
          if(newState == 'gallery_image_update'){
            this.showModal = true;
            this.fileType = 'image';
          }
          if(newState == 'image'){
            this.showModal = true;
            this.fileType = 'image';
          }
          if(newState == 'audio'){
            this.showModal = true;
            this.fileType = 'audio';
          }
          if(newState == 'video'){
            this.showModal = true;
            this.fileType = 'video';
          }
          if(newState == 'panorama_file_image'){
            this.showModal = true;
            this.fileType = 'panorama_image';
          }
          if(newState == 'panorama_file_video'){
            this.showModal = true;
            this.fileType = 'panorama_video';
          }
          if(newState == 'panorama_feature_audio'){
            this.showModal = true;
            this.fileType = 'audio';
          }
          if(newState == 'audio_feature_audio'){
            this.showModal = true;
            this.fileType = 'audio';
          }
          if(newState == 'audio_feature_background_image'){
            this.showModal = true;
            this.fileType = 'image';
          }
          if(newState == 'video_feature_video')
          {
            this.showModal = true;
            this.fileType = 'video';
          }
          if(newState == 'waypoints')
          {
            this.showModal = true;
            this.fileType = 'waypoints';
          }
          if(newState == 'providers_logo'){
            this.showModal = true;
            this.fileType = 'image';
          }
          if(newState == 'augmented_reality_feature_glb')
          {
            this.showModal = true;
            this.fileType = 'three_dimensional_object_glb';
          }
          if(newState == 'augmented_reality_feature_usdz')
          {
            this.showModal = true;
            this.fileType = 'three_dimensional_object_usdz';
          }
          if(newState == 'augmented_reality_feature_marker'){
            this.showModal = true;
            this.fileType = 'marker';
          }
          if(newState == 'augmented_reality_feature_audio'){
            this.showModal = true;
            this.fileType = 'audio';
          }
          if(newState == null){
            this.showModal = false;
            this.fileType = 'all';
          }
      }
  }
}
</script>
